
export default function SolutionsSection() {
  return (
    <section className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <img
              src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/1f2dfe9154008dd96673e9d1a23bbad6.jpeg"
              alt="Projetos técnicos P&P"
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div className="order-1 lg:order-2">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3F3F3F] mb-6">
              Além de projetos, soluções reais
            </h2>
            <div className="space-y-6 text-base text-[#3F3F3F] leading-relaxed">
              <p>
                Enquanto muitos enxergam obstáculos, nós vemos oportunidades de aprimorar cada detalhe.
              </p>
              <p>
                Trabalhamos com planejamento preciso, gestão rigorosa e execução alinhada às normas técnicas, garantindo que tudo saia como foi idealizado — ou melhor.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}